import { Component } from '@angular/core';
import { CardElementsBaseComponent } from './card-elements-base.component';

@Component({ template: '' })
/** Base Component Class for page elements */
export class CoreCardBaseComponent extends CardElementsBaseComponent {}
